module.exports = __webpack_public_path__ + "img/ico-download-gas.4c55f4a4.svg";